import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import ChangeNamePage from '@/settings/pages/change-name';

export const Route = createFileRoute('/settings/user-profile/change-name')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: ChangeNameRoute,
  staticData: {
    headerSection: null
  }
});

function ChangeNameRoute() {
  return <ChangeNamePage/>;
}
